import { Component, OnInit } from '@angular/core';
import { timer, Subscription } from 'rxjs'
import { faCircle, faChevronCircleLeft, faChevronCircleRight } from '@fortawesome/free-solid-svg-icons'
import { nextContext } from '@angular/core/src/render3';
import { DataService } from '../data.service';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss']
})
export class HomeComponent implements OnInit {

  faCircle = faCircle;
  faChevronCircleLeft = faChevronCircleLeft;
  faChevronCircleRight = faChevronCircleRight;

  imgTimer: Subscription;

  homePic = [];
  selected: number = 0;
  max:number = this.homePic.length;
  loaded: boolean;

  constructor(private data: DataService) {
    this.data.getHomeDB().subscribe(
      list => {
        this.homePic = list.map(item => {
          return {
            $key: item.key,
            ...item.payload.val()
          }
        })
        
        this.max = this.homePic.length;
        if(this.max > 0)
          this.imgTimer = timer(3000, 3000).subscribe(val => this.next());
        else
          this.selected = -1;
          
        this.max = this.homePic.length;
        this.loaded = true;
      }
    );}

  ngOnInit() {
  }

  imgLoop() {
    this.imgTimer.unsubscribe();
    if(this.max > 0)
      this.imgTimer = timer(3000, 3000).subscribe(val => {
        if(this.selected+1 === this.max){
          this.selected = 0;
        }
        else if(this.max === 0) {
          this.selected = -1;
        }
        else {
          this.selected++;
        }
      });
  }

  next() {
    if(this.selected+1 === this.max){
      this.selected = 0;
    }
    else if(this.max === 0) {
      this.selected = -1;
    }
    else {
      this.selected++;
    }
    this.imgLoop();
  }

  prev() {
    if(this.selected === 0){
      this.selected = this.max-1;
    }
    else {
      this.selected--;
    }
    this.imgLoop();
  }

  select(n:number){
    this.selected = n;
    this.imgLoop;
  }

}
